import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";
import { fetchCmsMetaData } from "../../Components/Utility/cmsMetaService";
import AddExperienceModal from "./Model/AddExperienceModal";

function HostChooseExperience() {

   const location = useLocation();
    const navigate = useNavigate();

  // ✅ Get category & subcategory from previous page
  const categoryId = location.state?.categoryId;
  const subCategoryId = location.state?.subCategoryId;
  const [meta,setMeta] = useState();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
   const [errorMsg, setErrorMsg] = useState("");
   const [loading, setLoading] = useState(false);
   const [firstLetter, setFirstLetter] = useState("R"); 
 const [experienceData, setExperienceData] = useState({
    title: "",
    about_me: "",
    total_year_of_experience: "",
    qualification: "",
  });
 

   // ✅ When modal saves data, merge it here
  const handleSave = (data) => {
    setExperienceData((prev) => ({
      ...prev,
      ...data,
    }));
    
  };

   const token = localStorage.getItem("authToken");

   useEffect(() => {
    if (
      experienceData.title &&
      experienceData.about_me &&
      experienceData.total_year_of_experience
    ) {
      setErrorMsg(""); // clear error automatically
    }
  }, [experienceData]);
   // ✅ Submit all data to API
  const handleNext = async () => {

    if (!experienceData.title || !experienceData.about_me || !experienceData.total_year_of_experience) {
     toast.error("Please fill Intro, Expertise and Experience before proceeding.");
    return;
    }

    try {
      setLoading(true);
      const payload = {
        
        title: experienceData.title,
        about_me: experienceData.about_me,
        // total_year_of_experience: Number(experienceData.total_year_of_experience),
        qualification: experienceData.qualification,
      };


       const res = await toast.promise( 
        axios.post(
        `${process.env.REACT_APP_API_BASE}/host/create-profile`,
        payload,
         {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ✅ token pass in header
        },
      }
      ),
       {
        loading: "Saving your experience...",
        success: "Experience saved successfully",
      
      }
    )

      // setErrorMsg("Experience saved successfully!");
       navigate("/reservation", {
      state: {
        categoryId,
        subCategoryId,
        total_year_of_experience: Number(experienceData.total_year_of_experience)
      },
    });
    } catch (err) {
      console.error("API Error:", err);
      const errMsg = err.response?.data?.message || "Something went wrong while creating profile.";
      toast.error(errMsg);
      // setErrorMsg("Failed to save experience");
    }finally{
      setLoading(false);
    }
  };

  useEffect(() => {
  const fetchExistingExperience = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/get-host-experience`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data?.data) {
        // ✅ Fill local state with API values
        setExperienceData({
          title: res.data.data.title || "",
          about_me: res.data.data.about_my_experience || "",
          total_year_of_experience: res.data.data.total_year_of_experience || "",
          qualification: res.data.data.qualification || "",
        });
      }
    } catch (error) {
      console.error("Error fetching experience", error);
    }
  };

  fetchExistingExperience();
}, []);

useEffect(() => {
  const saved = JSON.parse(localStorage.getItem("hostData")) || {};
  if (saved.title || saved.about_me || saved.total_year_of_experience || saved.qualification) {
    setExperienceData((prev) => ({
      ...prev,
      ...saved, // ✅ overwrite with saved values
    }));
  }
}, []);

  useEffect(() => {
    const userData = localStorage.getItem("user"); // 🔹 key must match how you store it
    if (userData) {
      try {
        const parsed = JSON.parse(userData);
        if (parsed.email) {
          setFirstLetter(parsed.email.charAt(0).toUpperCase());
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  // Disable Next button until all three required fields are filled
const isNextDisabled = !(
  experienceData.title &&
  experienceData.about_me &&
  experienceData.total_year_of_experience
);

// Add this new derived state
const [activeStep, setActiveStep] = useState("intro"); // default: only intro enabled

// Update step enabling logic dynamically
useEffect(() => {
  if (experienceData.title && !experienceData.about_me) {
    setActiveStep("expertise");
  } else if (experienceData.title && experienceData.about_me && !experienceData.total_year_of_experience) {
    setActiveStep("experience");
  } else if (experienceData.title && experienceData.about_me && experienceData.total_year_of_experience) {
    setActiveStep("done"); // all required done
  } else {
    setActiveStep("intro");
  }
}, [experienceData]);




   useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // ya "auto"
  }, []);

   useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("host-choose-experience");
      setMeta(data);
    };

    loadMeta();
  }, []);

  return (
    <>
      <section className="ser_v_araeea allpages what_experience al_bootm_spance">
          <SetMetaTags
        title= {meta?.meta_title || "Profile Complete | Weyfarin"}
        description={meta?.meta_description || "Profile Complete | Weyfarin"}
      
      />

         {errorMsg && (
          <div className="error-message" >
            {errorMsg}
          </div>
        )}
        <div className="container">
          <div className="abt_pgs_areea">
            <h5 className="usr_c">{firstLetter}</h5>
            <h2>Share your qualifications</h2>
          </div>

          <div className="choos_categary_listst">
            <div
              className="ad_ch_lists"
              onClick={() => {
                setModalType("intro");
                setModalOpen(true);
              }}
            >
              <div className={`ad_plsh ${experienceData?.title ? "experience_complete" : ""}`}> {experienceData.title ? "✔" : "+"}</div>			  
              <div className="ch_contntecc">
                <h4>Intro</h4>
                <p>Tell us more about yourself</p>
              </div>
              <div className="ad_arrow"> 
                <i className="fa fa-angle-right"></i>
              </div>
            </div>

            <div
              // className="ad_ch_lists"
              // onClick={() => {
              //   setModalType("expertise");
              //   setModalOpen(true);
              // }}
               className={`ad_ch_lists ${activeStep === "intro" ? "disabled-step" : ""}`}
  onClick={() => {
    if (activeStep !== "intro") {
      setModalType("expertise");
      setModalOpen(true);
    } else {
      toast.error("Please complete Intro first.");
    }
  }}
            >
              <div className={`ad_plsh ${experienceData?.about_me ? "experience_complete" : ""}`}> {experienceData.about_me ? "✔" : "+"}</div>
              <div className="ch_contntecc">
                <h4>Expertise</h4>
                <p>Showcase your experiences</p>
              </div>
              <div className="ad_arrow">
                <i className="fa fa-angle-right"></i>
              </div>
            </div>

            <div
              // className="ad_ch_lists"
              // onClick={() => {
              //   setModalType("experience");
              //   setModalOpen(true);
              // }}

               className={`ad_ch_lists ${activeStep !== "experience" && activeStep !== "done" ? "disabled-step" : ""}`}
  onClick={() => {
    if (activeStep === "experience" || activeStep === "done") {
      setModalType("experience");
      setModalOpen(true);
    } else {
      toast.error("Please complete Expertise first.");
    }
  }}
            >
              <div className={`ad_plsh ${experienceData?.total_year_of_experience ? "experience_complete" : ""}`}>{experienceData.total_year_of_experience ? "✔" : "+"}</div>
              <div className="ch_contntecc">
                <h4>Experience</h4>
                <p>How many years of experience</p>
              </div>
              <div className="ad_arrow">
                <i className="fa fa-angle-right"></i>
              </div>
            </div>

            <div
              className="ad_ch_lists"
              onClick={() => {
                setModalType("recognition");
                setModalOpen(true);
              }}
            >
              <div className={`ad_plsh ${experienceData?.qualification ? "experience_complete" : ""}`}>{experienceData.qualification ? "✔" : "+"}</div>
              <div className="ch_contntecc">
                <h4>Recognition (Optional)</h4>
                <p>Add a career highlight</p>
              </div>
              <div className="ad_arrow">
                <i className="fa fa-angle-right"></i>
              </div>
            </div>
          </div>

          <div class="rightss_links">
             <button
    type="button"
    className="btn btn-secondary"
    onClick={() => navigate("/host-subcategory")}
  >
    Back
  </button>
            <button 
            type="button"
    onClick={handleNext} 
   disabled={isNextDisabled || loading}
    className={`next-btn btn ${loading ? "disabled" : ""}`}
  >
    {loading ? "Loading..." : "Next"}
  </button>
          </div>
        </div>
      </section>

      <AddExperienceModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSave={handleSave}
        type={modalType}
        initialData={experienceData}
      />
    </>
  );
}

export default HostChooseExperience;
